// extracted by mini-css-extract-plugin
export default {"wrap":"ModalSelectCourier_wrap__hTdq-"};